import { Divider, Drawer, Space, Button, Radio, Row, Col, Slider, Input, Checkbox, Tooltip } from "antd";
import React, { useState, useEffect, useCallback, useRef } from "react";
import moment from "moment";
import ColourPicker from "../../../globals/styles/ColourPicker";
import { apiCall } from "../../../utils/Api";
import { getColor } from "../../../utils/ConvertCSS";
import { useTemplate } from "../../../utils/Template";
import EventUI from "../../UI/EventUI";
import PresetPicker from "../../../globals/styles/PresetPicker";
import BMInput from "../../comps/BMInput";
import { PicRightOutlined, PicLeftOutlined, PicCenterOutlined, FacebookOutlined, ShareAltOutlined } from '@ant-design/icons';
import ButtonPicker from "../../../globals/styles/ButtonPicker";
import { PaddingHorizontalIcon, PaddingVerticalIcon, TwitterIcon, BlueskyIcon, MastodonIcon, ThreadsIcon } from "../../Icons";
import LinkPicker from "../../../globals/styles/LinkPicker";
import SliderInput from "../../UI/SiderInput";
import { tt_buy_titles } from "../../../utils/Utils";

export default function Events(props) {

    const { view = "desktop" } = props;
    const [template,] = useTemplate();
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(false);
    const [content, setContent] = useState(props.content);
    const [w, setW] = useState(false);

    const [page, setPage] = useState(0);
    const observer = useRef();

    const fetchEvents = () => {
        setLoading(true);

        if (window.sitesettings.using_events_v2) {

            let _limit = 20;
            let _offset = page * _limit;

            apiCall("event/v2/list", { start_date: moment().format("YYYYMMDD"), limit: _limit, offset: _offset }, (_status, _result) => {
                if (_status) {
                    setEvents((prevRows) => [...prevRows, ..._result.rows]);
                }
                setLoading(false)
            }, "customer")
        } else {

            apiCall("event/getList", { from: moment().format("YYYYMMDD") }, (_status, _result) => {
                if (_status) {
                    setEvents(_result.rows);
                }
                setLoading(false);
            }, "customer")
        }
    }
    useEffect(fetchEvents, [page]);

    const lastRowRef = useCallback(
        (node) => {
            if (observer.current) observer.current.disconnect();
            observer.current = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting) {
                    setPage((prevPage) => prevPage + 1);
                }
            });
            if (node) observer.current.observe(node);
        },
        []
    );

    const { edit = false, close = () => { }, saveItem = () => { }, id = 0 } = props;

    const setData = (_data) => {
        setContent({ ...content, "data": _data })
    }

    // Component agnostic
    const {
        name = "",
        container = true,
        data = {},
        date_changed = 0
    } = content;

    // Component specific
    const {
        //new
        align = "center",
        container_width = 1248,
        constrain_container = false,

        width = 200,
        background_colour = 0,
        padding_x = 20,
        padding_y = 20,
        title_preset = 0,
        description_preset = 0,
        date_preset = 0,
        button_type = 0,
        button_label = "Buy Books",
        button_align = "left",
        link_id = 0,
    } = data;

    const save = () => {
        close();
        saveItem(id, { ...content })
    }

    const drawButtons = (eventData) => {

        // Buy Tickets
        // Buy Books
        // RSVP
        const {
            info = {},
            books = [],
            tickets = [],
            ticket_label = "",
            rsvp_label = "",
            attendance = false
        } = eventData;
        const { book = [], ticket = [] } = info;

        let _tickets = ticket;
        let _tickets_label = "Tickets"
        let _books = book;
        let _books_label = button_label;
        let _attendance = attendance;
        let _rsvp_label = "";

        // New Events
        if (window.sitesettings.using_events_v2) {
            _tickets = tickets;
            _tickets_label = (ticket_label) ? ticket_label : "Tickets";
            _books = books;
            _rsvp_label = (rsvp_label) ? rsvp_label : "RSVP";
        }

        return (
            <>
                <div className="shim" /><div className="shim" />
                <div style={{ "textAlign": button_align, "display": "block" }}>
                    {((_tickets.length > 0) && <Button className={"bm-btn-" + button_type}>{_tickets_label}</Button>)}
                    {((books.length > 0) && <Button className={"bm-btn-" + button_type}>{_books_label}</Button>)}
                    {((_attendance === "request") && <Button className={"bm-btn-" + button_type}>{_rsvp_label}</Button>)}
                </div>
            </>
        )
    }


    const drawImages = (eventData) => {

        const {
            info = {},
            image_url = "",
            title = "",
            books = []
        } = eventData;
        const { name = "", img_path = "", book = [] } = info;

        let _books = book;
        let _image = img_path;
        let _title = name;

        if (window.sitesettings.using_events_v2) {
            _books = books;
            _image = image_url;
            _title = title;
        }

        let _w = "50%";

        if (!_image && books.length === 1) {
            _w = "100%";
        }

        return (
            <div style={{ width: '100%', textAlign: 'center' }}>
                <div style={{ width: '100%' }}>
                    <img onError={i => i.target.style.display = 'none'} src={_image} alt={_title} style={{ width: '100%', height: 'auto' }} />
                </div>
                <div style={{ display: 'flex', justifyContent: "center", gap: "10px", width: '100%', paddingTop: '10px' }}>
                    {(_books.slice(0, 2).map(item => {
                        return (
                            <div style={{ width: _w }}>
                                <img onError={i => i.target.style.display = 'none'} src={"https://bookmanager.com/i/m?b=" + item.eisbn} alt={item.title} style={{ width: '100%', height: 'auto' }} />
                            </div>
                        )
                    }))}
                </div>
            </div>
        )
    }

    const drawEvent = (item) => {
        const {
            id = "",
            from = 0,
        } = item;

        let _wrapperStyle = {}
        let _bgStyle = {}

        return (
            <div key={item}>
                <div style={_bgStyle}>
                    <div style={_wrapperStyle}>
                        <Row gutter={[20, 40]} style={{ "flexWrap": (view === "desktop") ? "nowrap" : "wrap" }}>
                            <Col flex={(width + "px")}>
                                {drawImages(item)}
                                <br />
                                <div style={{ "textAlign": "center" }}>
                                    <Space>
                                        {window.storesettings.share_twitter && (<a target="_blank" rel="noopener noreferrer"><Button className={"bm-lnk-" + link_id} type="text" icon={<TwitterIcon style={{ "fontSize": "23px" }} />} /></a>)}
                                        {window.storesettings.share_facebook && (<a target="_blank" rel="noopener noreferrer"><Button className={"bm-lnk-" + link_id} type="text" icon={<FacebookOutlined style={{ "fontSize": "25px" }} />} /></a>)}
                                        {window.storesettings.share_bluesky && (<a target="_blank" rel="noopener noreferrer"><Button className={"bm-lnk-" + link_id} type="text" icon={<BlueskyIcon style={{ "fontSize": "25px" }} />} /></a>)}
                                        {window.storesettings.share_mastodon && (<a target="_blank" rel="noopener noreferrer"><Button className={"bm-lnk-" + link_id} type="text" icon={<MastodonIcon style={{ "fontSize": "25px" }} />} /></a>)}
                                        {window.storesettings.share_threads && (<a target="_blank" rel="noopener noreferrer"><Button className={"bm-lnk-" + link_id} type="text" icon={<ThreadsIcon style={{ "fontSize": "25px" }} />} /></a>)}
                                        <Button className={"bm-lnk-" + link_id} type="text" icon={<ShareAltOutlined style={{ "fontSize": "25px" }} />} />
                                    </Space>
                                </div>
                            </Col>
                            <Col flex="auto">
                                <EventUI
                                    view={view}
                                    link_id={link_id}
                                    event_id={id}
                                    flourish={false}
                                    title_preset={title_preset}
                                    date_preset={date_preset}
                                    description_preset={description_preset}
                                    event={item} />
                                {drawButtons(item)}
                            </Col>
                        </Row>
                    </div>
                </div>
                <Divider />
            </div>
        )
    }

    const drawRender = () => {
        let _style = {
            backgroundColor: getColor(background_colour, template),
            padding: padding_y + "px " + padding_x + "px",
            width: (constrain_container) ? container_width + "px" : "100%",
            margin: (align === "center") ? "0 auto" : (align === "right") ? "0 0 0 auto" : "initial"
        }
        return (
            <div id={"bm-" + id} className={(container) ? "preview-container" : ""}>
                <div style={_style}>
                    {events.map((item, index) => {
                        if (index === events.length - 1) {
                            return (<div ref={lastRowRef}>{drawEvent(item)}</div>)
                        } else {
                            return (<div>{drawEvent(item)}</div>)
                        }

                    })}
                </div>
            </div>
        )
    }

    const drawForm = () => {
        return (
            <>
                <div style={{ "fontSize": "18px", "lineHeight": "18px" }}><strong>{name}</strong></div>
                {(date_changed && <em style={{ "fontSize": "12px" }}>Last updated {moment(date_changed * 1000).format("MMM Do, YYYY h:mm a")}</em>)}
                <div className="shim" /><div className="shim" />
                <div style={{ "display": "flex", "justifyContent": "stretch" }}>
                    <Button onClick={() => save()} block size="small" type="primary"><small>Save Changes</small></Button>
                    <div style={{ "width": "10px" }}></div>
                    <Space>
                        <Button onClick={() => close()} size="small" type="default"><small>Cancel</small></Button>
                    </Space>
                </div>
                <div style={{ "margin": "0px -25px" }}><Divider style={{ "margin": "15px 0px" }} /></div>
                {/* CONTAINER */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LAYOUT</Divider>
                <div className="float-flex">
                    <div></div>
                    <Space>
                        <Radio.Group value={container} onChange={(e) => setContent({ ...content, "container": e.target.value })} >
                            <Radio value={false}><small>100% of the screen width</small></Radio>
                            <Radio value={true}><small>Container width (max 1248px)</small></Radio>
                        </Radio.Group>
                    </Space>
                </div>
                <div className="shim" /><div className="shim" />
                {/* BACKGROUND COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                <ColourPicker allow_gradient allow_none value={background_colour} onChange={(_v) => setData({ ...data, "background_colour": _v })} />
                <div className="shim" /> <div className="shim" />
                {/* PADDING */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PADDING</Divider>
                <div className="float-flex">
                    <Space>
                        <BMInput value={padding_x} onChange={(_v) => setData({ ...data, "padding_x": _v })} number min={0} max={100} prefix={<PaddingHorizontalIcon style={{ "color": "#888" }} />} />
                        <BMInput value={padding_y} onChange={(_v) => setData({ ...data, "padding_y": _v })} number min={0} max={100} prefix={<PaddingVerticalIcon style={{ "color": "#888" }} />} />
                    </Space>
                    <div></div>
                </div>
                <div className="shim" /> <div className="shim" />
                {/* MAX WIDTH */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">MAX WIDTH</Divider>
                <div className="float-flex">
                    <SliderInput
                        onBeforeChange={() => setW(true)}
                        onAfterChange={() => setW(false)}
                        width={90}
                        min={0}
                        max={1248}
                        onChange={(_v) => setData({ ...data, "container_width": _v })}
                        disabled={!constrain_container}
                        value={container_width}
                    />
                    <Checkbox onChange={(e) => setData({ ...data, "constrain_container": e.target.checked })} checked={constrain_container}><small>Constrain?</small></Checkbox>
                </div>
                <div className="shim" /><div className="shim" />

                {/* ALIGN */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">ALIGN</Divider>
                <div className="float-flex">
                    <div></div>
                    <Space>
                        <div><PicLeftOutlined onClick={() => setData({ ...data, "align": "left" })} style={{ "color": (align === "left") ? "#1890ff" : "#AAA" }} /></div>
                        <div><PicCenterOutlined onClick={() => setData({ ...data, "align": "center" })} style={{ "color": (align === "center") ? "#1890ff" : "#AAA" }} /></div>
                        <div><PicRightOutlined onClick={() => setData({ ...data, "align": "right" })} style={{ "color": (align === "right") ? "#1890ff" : "#AAA" }} /></div>
                    </Space>
                </div>

                {/* WIDTH */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">IMAGES WIDTH</Divider>
                <Slider defaultValue={width} onChange={(e) => setData({ ...data, "width": e })} min={100} max={500} />
                <div className="shim" /> <div className="shim" />
                {/* TITLE PRESET */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">EVENT TITLE PRESET</Divider>
                <PresetPicker value={title_preset} onChange={(e) => setData({ ...data, "title_preset": e })} />
                <div className="shim" /> <div className="shim" />
                {/* DESCRIPTION PRESET */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">EVENT DATE PRESET</Divider>
                <PresetPicker value={date_preset} onChange={(e) => setData({ ...data, "date_preset": e })} />
                <div className="shim" /> <div className="shim" />
                {/* DESCRIPTION PRESET */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">EVENT DESCRIPTION PRESET</Divider>
                <PresetPicker value={description_preset} onChange={(e) => setData({ ...data, "description_preset": e })} />
                <div className="shim" /> <div className="shim" />
                {/* BUTTON LABEL */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BUY TITLES LABEL</Divider>
                <Tooltip title={tt_buy_titles}>
                    <Input style={{ "fontSize": "11px" }} onChange={(e) => setData({ ...data, "button_label": e.target.value })} value={button_label} placeholder="Label..." />
                </Tooltip>
                <div className="shim" /> <div className="shim" />
                {/* BUTTON TYPE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BUTTON TYPE</Divider>
                <ButtonPicker value={button_type} onChange={(e) => setData({ ...data, "button_type": e })} />
                <div className="shim" /> <div className="shim" />
                {/* ALIGN */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BUTTON ALIGN</Divider>
                <div className="float-flex">
                    <div></div>
                    <Space>
                        <div><PicLeftOutlined onClick={() => setData({ ...data, "button_align": "left" })} style={{ "color": (button_align === "left") ? "#1890ff" : "#AAA" }} /></div>
                        <div><PicCenterOutlined onClick={() => setData({ ...data, "button_align": "center" })} style={{ "color": (button_align === "center") ? "#1890ff" : "#AAA" }} /></div>
                        <div><PicRightOutlined onClick={() => setData({ ...data, "button_align": "right" })} style={{ "color": (button_align === "right") ? "#1890ff" : "#AAA" }} /></div>
                    </Space>
                </div>
                <div className="shim" /> <div className="shim" />

                {/* LINK STYLE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LINK STYLE</Divider>
                <LinkPicker value={link_id} onChange={(e) => setData({ ...data, "link_id": e })} />
                <div className="shim" /> <div className="shim" />
            </>
        )
    }
    return (
        <>
            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX": "hidden" }} closable={false} width={300} onClose={() => close(true)} open={edit}>
                {drawForm()}
            </Drawer>
            {drawRender()}
        </>
    )

}